import { Add, Edit, Minus, Trash } from "iconsax-react";

export default function ReportItemTypeTreeDecorator(props) {
    const { node } = props;
    const toggleHandle = (e) => {
        e.stopPropagation();
        props.onClick();
    };

    const color =
        props.decorators.selectedNode?.id === node?.id ? "white" : "#333";
    return (
        <div
            className={`s-tree-btn ${node.level === 1 ? "blue" : ""} ${
                props.decorators.selectedNode?.id === node?.id ? "selected" : ""
            }`}
            onClick={() => props.decorators.onSelect(node)}
        >
            {(node.children?.length > 0) &&
                (node.toggled ? (
                    <Minus size="18" color={color} onClick={toggleHandle} />
                ) : (
                    <Add size="18" color={color} onClick={toggleHandle} />
                ))}
            <span>{node.name}</span>
        </div>
    );
}
